import React, { useEffect, useState } from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, LinearProgress, Switch, Tooltip } from "@mui/material";
import { Formik, Form } from 'formik'
import * as Yup from 'yup'

import { Add, Edit } from '@mui/icons-material';

import FormikControl from '../../../../../components/FormikControl/FormikControl';
import transactionServices from '../transactionServices';
import { useAlert } from '../../../../../context/AlertContext';
import { useAppData } from '../../../../../context/AppDataContext';
import moment, { HTML5_FMT } from 'moment';
import { POTransactionAllocationForm } from './POTransactionAllocationForm';
import { ProjectTransactionAllocationForm } from './ProjectTransactionAllocationForm';



function TransactionForm({data,callBack }) {

    const {AppAlert} = useAlert();
    const {masters,companyDD} = useAppData();
    const [formValues, setFormValues] = useState(null);
    const [dialogStatus, setDialogStatus] = useState(false);
    const [savingInProgress, setSavingStatus] = useState(false);

    const [isPoPayment,setIsPoPayment] = useState(false);
    const [poTransactionList,setPoTransactionList] = useState(null);
    const [projectTransactionList,setProjectTransactionList] = useState([]);

    const [totalAlloted,setTotalAlloted] = useState(0);

    const initialValues = {        
        companyId:"",
        transactionAmount:"",
        transactionMethod:"",
        transactionNo:"",
        transactionDate:moment().format(moment.HTML5_FMT.DATE),
    }


    const updateData = ()=>{
        let autoFill = {
            id:data.id,
            companyId:data.companyId,
            transactionAmount:data.transactionAmount,
            transactionMethod:data.transactionMethod,
            transactionNo:data.transactionNo,
            transactionDate:data.transactionDate,
        }
        setFormValues(autoFill);
        setDialogStatus(true)
    }

    const validationRule = Yup.object({
        companyId:Yup.number().required("Required"),
        transactionAmount:Yup.number().required("Required"),
        transactionMethod:Yup.string().required("Required"),
        transactionNo:Yup.string().required("Required").trim('Transaction No cannot include leading and trailing spaces').strict(true).min(4, 'The contact name needs to be at least 1 char'),
        transactionDate:Yup.string().required("Required"),
    });

    const addNew = ()=>{
        setFormValues(initialValues);
        setDialogStatus(true)
    }

    const handleClose  = () =>{
        setDialogStatus(false);
    }

    const preparePayload = (values) =>{

        

        let payload ={
            transactionData : {
                companyId:values.companyId,
                transactionAmount:values.transactionAmount,
                transactionMethod:values.transactionMethod,
                transactionNo:values.transactionNo,
                transactionDate:values.transactionDate,
            }
        }

        if(isPoPayment){
            payload.poTransactionList =  poTransactionList.filter(po => po.amount > 0).map(po=>{
                    return ({
                        poId:po.poId,
                        projectId:po.projectId,
                        transactionCategory:1, // Direct vendor Payment
                        payeeType:po.payeeType,
                        payeeId:po.payeeId,
                        amount:po.amount,
                    })
                }
            )
        } else {
            payload.projectTransactionList =  projectTransactionList.map(project=>{
                    return ({
                        projectId:project.projectId,
                        transactionCategory:project.transactionCategory.value,
                        payeeType:project.payeeType,
                        

                        payeeId:project.paidTo===""?null:project.paidTo.value,

                        payeeName:project.payeeName===""?null:project.payeeName,
                        amount:project.amount,
                    })
                }
            )
        }
        return payload;

    }


    const validateList = (projectTransactionList) => {
        // 1. Check if the list itself is empty
        if (!projectTransactionList || projectTransactionList.length === 0) {
            return { error: true, msg: "Transaction list cannot be empty" };
        }

        for (let i = 0; i < projectTransactionList.length; i++) {
            const item = projectTransactionList[i];
            const rowNum = i + 1;

            // Rule 1: transactionCategory check
            if (!item.transactionCategory || item.transactionCategory === "") {
                return { error: true, msg: `Row ${rowNum}: Transaction Category is required` };
            }

            // Rule 2: payeeType check
            if (!item.payeeType || item.payeeType === "" || item.payeeType === null ) {
                return { error: true, msg: `Row ${rowNum}: Payee Type is required` };
            }

            // Rule 3: amount check (should be present and greater than 0)
            if (!item.amount || Number(item.amount) <= 0) {
                return { error: true, msg: `Row ${rowNum}: Amount must be a valid number greater than 0` };
            }

            // Rule 4: Conditional - payeeName (If payeeType == 11)
            if (item.payeeType == "11") {
                if (!item.payeeName || item.payeeName.trim() === "") {
                    return { error: true, msg: `Row ${rowNum}: Payee Name is required for this payee type` };
                }
            }

            // Rule 5: Conditional - payeeId (If payeeType < 10)
            if (Number(item.payeeType) < 10) {
                if (item.payeeId === null || item.payeeId === undefined || item.payeeId === "") {
                    return { error: true, msg: `Row ${rowNum}: Payee ID is required for this payee type` };
                }
            }
        }

        // If the loop finishes without returning, everything is valid
        return { error: false };
    };

    const onSubmit = (values, { resetForm }) => {
        let payload = preparePayload(values)
        const validation = validateList(payload.projectTransactionList);

        

        if (!isPoPayment && validation.error) {
        // Use your existing AppAlert function
            AppAlert(validation.msg, 'error');
            return; // Stop the submission
        }
        AppAlert("Everything Good Please Proceed");

        console.log(payload);
        
        transactionServices.save(payload).then(res=>{
            AppAlert(res.msg);
            setDialogStatus(false);
            resetForm();
            setPoTransactionList(null)
            setProjectTransactionList([]);
            callBack();

        }).catch(error=>{
            AppAlert(error.msg,"error");
        }).finally(()=>{
            setSavingStatus(false);
        })
        
    }

    return (
        <>
            {!data &&
                <Tooltip title="Add New">
                    <button type="button" className="btn btn-primary" onClick={addNew} ><Add/> Add New Transaction</button>
                </Tooltip>
            }
            {data && false &&
                <Tooltip title="Update">
                    <IconButton onClick={updateData} style={{padding:"0px"}}>
                        <Edit/>
                    </IconButton>
                </Tooltip>
            }
            <Dialog
                open={dialogStatus}
                keepMounted
                onClose={handleClose}
                fullWidth={true}
                maxWidth="xl"
                
            >

                <Formik
                    initialValues={formValues || initialValues}
                    validationSchema={validationRule}
                    onSubmit={onSubmit}
                    enableReinitialize validateOnMount
                >
                    {
                        (formik) => {
                            //console.log(formik.values);
                            return (
                                <Form>
                                    <DialogTitle>{"Transaction"}</DialogTitle>
                                    <DialogContent>
                                            <div className="row p-3">

                                                
                                                <div className='col-md-6 my-2'>
                                                    <FormikControl control="autoselect" formik={formik} 
                                                        label="Select Company" name="companyId"  
                                                        options={companyDD} multiple={false} 
                                                    />
                                                </div>

                                                <div className='col-md-6 my-2'>
                                                    <FormikControl control="autoselect" formik={formik} 
                                                        label="Payment Method" name="transactionMethod"  
                                                        options={masters['transaction-method']} multiple={false} 
                                                    />
                                                </div>

                                                
                                                <div className="col-md-4 my-2" >
                                                    <FormikControl control="input" formik={formik} type="date" 
                                                        label="Transection Date" name="transactionDate" 
                                                    />
                                                </div>

                                                

                                                <div className="col-md-4 my-2" >
                                                    <FormikControl control="input" formik={formik} type="text" 
                                                        label="Transection No" name="transactionNo" 
                                                    />
                                                </div>

                                                <div className="col-md-4 my-2" >
                                                    <FormikControl control="input" formik={formik} type="number" 
                                                        label="Transaction Amount" name="transactionAmount" 
                                                    />
                                                </div>

                                                <hr/>
                                            
                                                {(formik.values.transactionAmount !== "" && formik.values.transactionAmount !==0) &&
                                                    <>
                                                        <div className='bg-info p-3 pb-2 col-md-12'>
                                                            <div className="d-flex justify-content-center" >
                                                                <span className='fw-bold mx-3'>Direct Payment </span>
                                                                <Switch 
                                                                    checked={isPoPayment}
                                                                    onChange={(e)=>setIsPoPayment(e.target.checked)}
                                                                />
                                                                <span className='fw-bold ms-3'>PO Payment </span>
                                                            </div>
                                                        </div>   
                                                        {isPoPayment?
                                                            <POTransactionAllocationForm
                                                                transactionAmount={formik.values.transactionAmount} 
                                                                poTransactionList={poTransactionList} setPoTransactionList={setPoTransactionList} 
                                                                totalAlloted={totalAlloted} setTotalAlloted={setTotalAlloted}
                                                            />
                                                            :
                                                            <ProjectTransactionAllocationForm
                                                                transactionAmount={formik.values.transactionAmount} 
                                                                projectTransactionList={projectTransactionList} 
                                                                setProjectTransactionList={setProjectTransactionList}
                                                                totalAlloted={totalAlloted} setTotalAlloted={setTotalAlloted}
                                                            />
                                                        }
                                                </>

                                                }
                                            </div>
                                                                                       
                                        <div className="row mt-3">
                                            <div className='col-md-12'>
                                                {savingInProgress ?
                                                    <LinearProgress/>
                                                    :
                                                    <>
                                                        <button className="btn btn-primary float-end" type="submit" disabled={totalAlloted !== formik.values.transactionAmount || !formik.isValid}  >Save</button>
                                                        <button className="btn btn-outline-primary" type="button" onClick={handleClose}>Cancel</button>
                                                    </>
                                                }
                                            </div>
                                            <div className='col-md-12'>
                                                {/* JSON.stringify(formik) */ }
                                            </div>
                                        </div>
                                    </DialogContent>
                                </Form>
                            )
                        }
                    }
                </Formik>
            </Dialog>

        </>
    )
}

export default TransactionForm